import { Fragment } from "react";
import { NoteMessageContainer } from "../../../Layout/Common/alert/noteMessageContainer";
import { NOTEMESSAGE, SHIPPING_METHOD } from "../../../constants";
import { Link } from "react-router-dom";

export const NoShippingAvailable = () => {
  const { SHIPPINGNOTAVAILABLE } = NOTEMESSAGE;
  return (
    <Fragment>
      <div className="delivery-method">
        <NoteMessageContainer
          heading={SHIPPINGNOTAVAILABLE.title}
          contant={SHIPPINGNOTAVAILABLE.content}
          className="yellow-note-container"
        />
        <div className="checkout-button">
          <Link
            to="/OrderDetails"
            className="return-to-cart d-none d-md-block return-link"
          >
            <i className="fa-solid fa-chevron-left" /> Return to Cart
          </Link>
        </div>
      </div>
    </Fragment>
  );
};
